var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "80vh"
        },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_test_preview_modal,
        callback: function($$v) {
          _vm.show_test_preview_modal = $$v
        },
        expression: "show_test_preview_modal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_test_preview_modal = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("preview")) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c("div", { staticClass: "row gutter-sm q-mb-md" }, [
                _c("div", { staticClass: "col-xs-10 col-sm-10" }, [
                  _c("p", { staticClass: "caption text-weight-bold" }, [
                    _vm._v(_vm._s(_vm.title ? _vm.title : ""))
                  ])
                ])
              ]),
              _c("div", { staticClass: "row q-mb-lg" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-6 col-sm-3" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("random_questions")))
                    ]),
                    _c("q-btn-toggle", {
                      attrs: {
                        "toggle-color": _vm.randomize_questions
                          ? "positive"
                          : "negative",
                        options: _vm.randomize_questions_options,
                        disable: ""
                      },
                      model: {
                        value: _vm.randomize_questions,
                        callback: function($$v) {
                          _vm.randomize_questions = $$v
                        },
                        expression: "randomize_questions"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-6 col-sm-3" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("random_answers")))
                    ]),
                    _c("q-btn-toggle", {
                      attrs: {
                        "toggle-color": _vm.randomize_answers
                          ? "positive"
                          : "negative",
                        options: _vm.randomize_answers_options,
                        disable: ""
                      },
                      model: {
                        value: _vm.randomize_answers,
                        callback: function($$v) {
                          _vm.randomize_answers = $$v
                        },
                        expression: "randomize_answers"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._l(_vm.preview_questions, function(question, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-12 q-mb-xl" },
                  [
                    _c(
                      "div",
                      { staticClass: "row q-col-gutter-md" },
                      [
                        _c("div", { staticClass: "col-12 q-pa-md" }, [
                          _c("span", [_vm._v(_vm._s(index + 1 + ") "))]),
                          _c("span", {
                            domProps: { innerHTML: _vm._s(question.title) }
                          })
                        ]),
                        _vm._l(question.answers, function(answer) {
                          return _c(
                            "div",
                            { key: answer.id, staticClass: "col-12" },
                            [
                              _c(
                                "q-card",
                                {
                                  staticClass: "cursor-pointer",
                                  attrs: { flat: "" }
                                },
                                [
                                  _c(
                                    "q-card-main",
                                    [
                                      _c(
                                        "q-item",
                                        {
                                          directives: [
                                            {
                                              name: "ripple",
                                              rawName: "v-ripple"
                                            }
                                          ],
                                          attrs: { dense: "" }
                                        },
                                        [
                                          _c(
                                            "q-item-side",
                                            [
                                              _c(
                                                "q-item-tile",
                                                { attrs: { avatar: "" } },
                                                [
                                                  _c("q-icon", {
                                                    staticClass: "q-pt-sm",
                                                    attrs: {
                                                      name: answer.is_correct
                                                        ? "far fa-check-circle"
                                                        : "far fa-circle",
                                                      color: answer.is_correct
                                                        ? "green"
                                                        : "red",
                                                      size: "1.5rem"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c("q-item-main", {
                                            attrs: { label: answer.title }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("q-card-separator")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              }),
              _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12 col-sm-3",
                    class: this.$q.platform.is.mobile
                      ? "order-last"
                      : "order-first"
                  },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "tertiary",
                        label: _vm.$t("close"),
                        icon: "far fa-block"
                      },
                      on: {
                        click: function($event) {
                          _vm.show_test_preview_modal = false
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }